import React, { useState } from "react"
import { Modal, Button } from "react-bootstrap"
import PropTypes from "prop-types"
import { FormattedMessage } from "react-intl"

import { API_STATUS } from "../../../shared_components/widgets/utils"
import { logToServer } from "../../../ErrorBoundary"
import { addNewObject } from "../../../Loaders"

/* Modal to manually trigger sending of file. */
export default function ModalSendFile({ dataExportRqID, show, onHide, onSuccess }) {
  const [statusSend, setStatusSend] = useState(null)
  const [error, setError] = useState(null)

  const sendFileTrigger = () => {
    setStatusSend(API_STATUS.LOADING)
    setError(null)

    addNewObject(`/lake/data-export-requests/${dataExportRqID}/trigger_send_file/`, {
      confirm: 1,
    })
      .then((response) => {
        setStatusSend(API_STATUS.SUCCESS)
        onHide()
        onSuccess(response)
      })
      .catch((error) => {
        logToServer(error)
        setStatusSend(API_STATUS.ERROR)
        setError(error)
      })
  }

  return (
    <Modal show={show} onHide={onHide} backdrop={"static"} keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title>
          <i className={"fa fa-paper-plane-o"} />
          &nbsp;&nbsp;
          <FormattedMessage id={"datatransfer.sendfile"} />
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div align={"center"}>
          <p>
            <FormattedMessage id={"datatransfer.sendfile.areyousure"} />
          </p>

          {statusSend === API_STATUS.LOADING && (
            <div>
              <div className="spinner-border text-primary text-center" role="status" />
              &nbsp;
              <FormattedMessage id={"general.loading"} description={"Loading..."} />
              ...
            </div>
          )}

          {statusSend === API_STATUS.ERROR && (
            <div className={"text-danger"}>
              <FormattedMessage id={"datatransfer.sendfile.unable_to_send"} />:
              <div className={"text-danger"}>{error}</div>
            </div>
          )}

          {statusSend !== API_STATUS.LOADING && (
            <div className={"row"} style={{ width: "70%", marginTop: "20px" }}>
              <div className={"col-6"}>
                <Button variant={"outline-primary"} className={"btn btn-sm btn-block"} onClick={onHide}>
                  <FormattedMessage id={"general.cancelButton"} />
                </Button>
              </div>
              <div className={"col-6"}>
                <Button
                  variant={"outline-primary"}
                  className={"btn btn-sm btn-block"}
                  onClick={sendFileTrigger}
                >
                  <FormattedMessage id={"datatransfer.sendfile"} />
                </Button>
              </div>
            </div>
          )}
        </div>
      </Modal.Body>
    </Modal>
  )
}

ModalSendFile.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  dataExportRqID: PropTypes.number.isRequired,
}
